import { ApiBase } from './ApiBase';
class ReportsApiClientModel extends ApiBase {
    constructor() {
        super(...arguments);
        this.getReportsDefinitions = () => {
            return this.get(`/v3/reports/definitions`);
        };
        this.getReport = (pathParams, queryParams) => {
            return this.get(`/v3/reports/${pathParams.id}`, queryParams);
        };
        this.getReportCSV = (pathParams, queryParams) => {
            return this.get(`/v3/reports/${pathParams.id}/csv`, queryParams);
        };
        this.getReportFilters = (pathParams) => {
            return this.get(`/v3/reports/${pathParams.id}/filters`);
        };
    }
}
export const ReportsApiClient = new ReportsApiClientModel();
